import React, { useState, useMemo } from 'react';
import { Box, Typography, Dialog, CircularProgress } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import ResponsiveListContainer from '../../ResponsiveListContainer';
import GeneralDatePickerComponent from '../../components/GeneralDatePickerComponent';
import KartesetSingleRow from './SingleRow';
import KartesetTitleComponent from './TitleComponent';
import { endOfYear, startOfYear, subYears, parseJSON } from 'date-fns';

import {buildDebts} from "../../../../../types/CartesetDataHolder";
import {useGetCustomerAllDocuments} from "../../../../../hooks/customer/documents.hooks";
import {deserializeCarteset} from "../../../../../types/DocumentsTypes/utils";
import {useQueryClient} from "react-query";
import {useDispatch} from "react-redux";


const TitleComponent = ({ label, customer, setDisplayedData, documentType, date, setDate }) => {
    return (
        <Box sx={{ display: 'flex', maxHeight: '50px', padding: '5px 5px 0px 45px', alignItems: 'center' }}>
            <Typography sx={{ display: 'flex', fontSize: '15px', fontWeight: 'bold', color: 'black', lineHeight: '15px' }}>
                {documentType.name} לכבוד: {customer?.name || 'משתמש לא נמצא'}
            </Typography>
            <GeneralDatePickerComponent mainContent={[]} setDisplayedData={setDisplayedData} singleDateMode={true} />
        </Box>
    );
};

const KartesetMobile = ({ id, fullScreen = false, onClose }) => {
    const [searchParams] = useSearchParams();

    const [range, setRange] = useState([subYears(startOfYear(new Date()), 1), endOfYear(new Date())]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogData, setDialogData] = useState([]);
    const dispatch = useDispatch();
    const cache = useQueryClient();
    React.useEffect(() => {
        cache.removeQueries('CUSTOMER_DOCUMENTS_FOR_DEBT');

    }, []);
    // Fetch documents
    const { data: docs, isLoading ,refetch} = useGetCustomerAllDocuments(
        parseJSON(range[0]),
        parseJSON(range[1]),
        true,
        id,
        true,
        true,
        undefined,
        undefined,
        'CUSTOMER_DOCUMENTS_FOR_DEBT'
    );
    React.useEffect(() => {
        if (!isLoading) {
            cache.removeQueries('CUSTOMER_DOCUMENTS_FOR_DEBT');
            refetch();
        }
    }, [range, dispatch]);
    // Build carteset data
    const carteset = useMemo(() => {
        if (!docs) return [];
        return buildDebts(docs.filter((d) => (d.type == 'receipt' || d.type == 'invoice' || d.type == 'tax_invoice' || d.type == 'refund' || d.type == 'debt' || d.type == 'sup_invoice' || d.type == 'sup_tax_invoice' || d.type === 'sup_refund' || d.type === 'sup_receipt' || d.type == 'sup_debt')).map((t) => deserializeCarteset(t)), parseJSON(range[0]!))
    }, [docs, range]);

    // Handler for row click
    const handleDebtClick = (row) => {
        setDialogData([row]);
        setDialogOpen(true);
    };

    return (
        <>
            {fullScreen ? (
                <Box
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        bgcolor: 'background.paper',
                        zIndex: 2000,
                        overflow: 'auto',
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                        <Box
                            component="button"
                            onClick={onClose}
                            sx={{
                                background: 'none',
                                border: 'none',
                                fontSize: 28,
                                cursor: 'pointer',
                                color: 'grey.700',
                                position: 'absolute',
                                top: 16,
                                right: 24,
                                zIndex: 2100,
                            }}
                            aria-label="סגור"
                        >
                            ×
                        </Box>
                    </Box>
                    <Box sx={{ p: { xs: 1, sm: 3 } }}>
                        <ResponsiveListContainer
                            SingleRowComponent={(props) => <KartesetSingleRow {...props} onDebtClick={handleDebtClick} />}
                            TitleComponent={(props) => <KartesetTitleComponent {...props} id={id} range={range} /> }
                            mainContent={carteset}
                        />
                    </Box>
                </Box>
            ) : (
                <ResponsiveListContainer
                    SingleRowComponent={(props) => <KartesetSingleRow {...props} onDebtClick={handleDebtClick} />}
                    TitleComponent={KartesetTitleComponent}
                    mainContent={carteset}
                />
            )}
        </>
    );
};

export default KartesetMobile;
